import { render, staticRenderFns } from "./MenuMain.vue?vue&type=template&id=0ae22ee0&scoped=true&"
import script from "./MenuMain.vue?vue&type=script&lang=js&"
export * from "./MenuMain.vue?vue&type=script&lang=js&"
import style0 from "./MenuMain.vue?vue&type=style&index=0&id=0ae22ee0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae22ee0",
  null
  
)

export default component.exports